import { useSelector } from 'react-redux'
import { getMembershipType } from '../utils/getMembershipType'

const useMembershipInfo = () => {
  const profile = useSelector(state => state.profile.me)

  if (!profile) return null

  const membershipInfo = getMembershipType(profile)

  return membershipInfo
}

export default useMembershipInfo
